(function(window, document) {
	'use strict';

	mint.on('documentLoaded', function() {

		// bestehende Padding auslesen und Scrollbar-Breite auf alle Container addieren
		document.addEventListener('scroll-lock.activate', function(event) {
			document.querySelectorAll('.container--outer').forEach(function(container) {
				container.style.paddingRight = event.detail.scrollbarWidth + parseInt(mint.getCssProperty(container, 'padding-right')) + 'px';
			});
		});

		// gesetzte Paddings (per Style-Attribute) entfernen
		document.addEventListener('scroll-lock.deactivate', function(event) {
			document.querySelectorAll('.container--outer').forEach(function(container) {
				container.removeAttribute('style');
			});
		});
	});
})(window, document);
